import { useField } from 'formik';

import { useLocalize } from '@treams/treams-hooks/useLocalize';
import * as graphql from '@treams/treams-network';
import { FlexGap } from '@treams/treams-ui/common/FlexGap';
import { Radio } from '@treams/treams-ui/common/Radio';
import { Checkbox } from '@treams/treams-ui/form/controls/Checkbox';
import { tokens } from '@treams/treams-ui/theme/tokens';

export default function MultipleChoiceInput(props: {
	name: string;
	item: graphql.EvaluationMultipleChoiceItem;
}) {
	const { localize } = useLocalize();
	const [{ value }, , { setValue }] = useField<number[] | null>(props.name);
	const selected = value ?? [];
	const multiple =
		props.item.optionsMethod === graphql.EvaluationMultipleChoiceOptionsMethod.Multiple;

	const toggle = (index: number) => {
		if (!multiple) {
			setValue([index]);
			return;
		}

		const next = selected.includes(index)
			? selected.filter((item) => item !== index)
			: [...selected, index];
		setValue(next.sort((left, right) => left - right));
	};

	const options = props.item.options.map((option, index) => {
		const label = localize(option.text).text;

		if (multiple) {
			return (
				<Checkbox
					key={index}
					label={label}
					checked={selected.includes(index)}
					onClick={() => toggle(index)}
				/>
			);
		}

		return (
			<Radio.Card
				key={index}
				title={label}
				checked={selected.length === 1 && selected[0] === index}
				onChange={() => toggle(index)}
			/>
		);
	});

	if (multiple) {
		return (
			<FlexGap flexDirection="column" gap={tokens.gap.list}>
				{options}
			</FlexGap>
		);
	}

	return (
		<FlexGap
			role="radiogroup"
			aria-label={localize(props.item.title).text}
			flexDirection="column"
			gap={tokens.gap.list}
		>
			{options}
		</FlexGap>
	);
}
